module.exports = __webpack_public_path__ + "img/video.ae51de7b.svg";